import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const names = ['Martín', 'Julieta', 'Tomás', 'Florencia', 'Ignacio', 'Valentina', 'Facundo', 'Camila', 'Agustín', 'Lucía'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Neuquén', 'Salta', 'Santa Fe'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
      setData({
        name: randomName,
        city: randomCity,
        time: `hace ${randomTime} min`
      });
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-113">
      <div className="bg-white rounded-lg shadow-xl p-3 pr-8 flex items-center gap-3 border-l-4 border-accent-base relative max-w-[280px]" data-id="element-114">
        <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-115">
          <X className="w-3 h-3" data-id="element-116" />
        </button>

        <div className="bg-brand-light p-2 rounded-full text-accent-base flex-shrink-0" data-id="element-117">
          <ShoppingBag className="w-4 h-4" data-id="element-118" />
        </div>

        <div data-id="element-119">
          <p className="text-xs text-gray-800 leading-tight" data-id="element-120">
            <span className="font-bold" data-id="element-121">{data.name}</span> de {data.city} acaba
            de comprar{' '}
            <span className="font-semibold text-brand-base" data-id="element-122">
              Handball Performance Pro
            </span>
          </p>
          <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-123">{data.time}</p>
        </div>
      </div>
    </div>;
}